/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext } from "react";
import styles from "../css/SetupForm.module.css";
import { openDB } from "idb";
import Context from "../context/context";
const PageConfigurationForm = ({ setPageConfigurationModalOpen, invoiceSetup, setInvoiceSetup }) => {
  const [pageConfiguration, setPageConfiguration] = useState({
    left_margin: "",
    right_margin: "",
    bottom_margin: "",
    page_height: "",
    page_width: "",
    page_type: "",
    orientation: "",
  });
  const context = useContext(Context);
  const { updateUnSync } = context;

  useEffect(() => {
    const getData = () => {
      setPageConfiguration({
        ...pageConfiguration,
        ...invoiceSetup?.page_configuration,
        page_type: invoiceSetup?.page_configuration?.page_type === "F" ? "F" : "V",
        orientation: invoiceSetup?.page_configuration?.orientation === "P" ? "P" : "L",
      });
    };
    getData();
  }, []);

  const formSubmits = async (e) => {
    e.preventDefault();
    const db = await openDB('FoodDo', +localStorage.getItem('IDBVersion') || 1);
    const outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
    let outlet = (await outletStore.getAll())[0];

    const updatedSetup = {
      ...invoiceSetup,
      page_configuration: { ...invoiceSetup.page_configuration, ...pageConfiguration }
    }

    const invoice_setup = await outlet.invoice_setup?.filter(i => i.brand_uuid !== invoiceSetup.brand_uuid) || []
    await invoice_setup.push({ ...updatedSetup })
    outlet = await { ...outlet, invoice_setup }

    console.log("outlet", outlet);
    await outletStore.put(outlet);
    setInvoiceSetup(updatedSetup)
    handleInvoiceUnsyncedFile(outlet);
    setPageConfigurationModalOpen(false);
  };

  // Adding/Editing  outlet details to unsynced_files collection in IndexedDB
  const handleInvoiceUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
    const ndata = {
      invoice_setup: data.invoice_setup,
      RECON_TIME: new Date().getTime().toString(),
      IDENTIFIER: "invoice_setup",
    };
    await tx.put(ndata);
    handleInvoiceReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing invoice to reconciliation collection in IndexedDB
  const handleInvoiceReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("reconciliation", "readwrite").objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const othersJsonExists = allReconRecords.find((curr) => curr.IDENTIFIER === "others");
    if (othersJsonExists) {
      const invoice = othersJsonExists?.details?.filter((entry) => entry.type !== 'invoice_setup')
      const editData = {
        ...othersJsonExists,
        details: [
          ...invoice,
          {
            type: 'invoice_setup',
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData)
    } else {
      const newdata = {
        IDENTIFIER: "others",
        details: [
          {
            type: 'invoice_setup',
            RECON_TIME: data.RECON_TIME,
          },
        ]
      };
      await tx.add(newdata);
    }
  }

  return (
    <form className={styles.form} onSubmit={formSubmits}>
      <div className={styles.heading}>
        <h1>Page Configuration</h1>
      </div>

      <div className={styles.formContainer}>
        <div className={styles.formGroup}>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Left Margin
              <input
                type="number"
                name="left_margin"
                className={styles.numberInput}
                onInput={(e) => (e.target.value = e.target.value.slice(0, 4))}
                value={pageConfiguration.left_margin}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>

            <label className={styles.selectLabel}>
              Right Margin
              <input
                name="right_margin"
                className={styles.numberInput}
                type="text"
                maxLength="4"
                value={pageConfiguration.right_margin}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>
          </div>

          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Bottom Margin
              <input
                type="text"
                name="bottom_margin"
                className={styles.numberInput}
                maxLength="4"
                value={pageConfiguration.bottom_margin}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Page Height
              <input
                type="text"
                name="page_height"
                className={styles.numberInput}
                maxLength="4"
                style={{ "-moz-appearance": "textfield", width: "100%" }}
                disabled={pageConfiguration.page_type === "F" ? false : true}
                value={pageConfiguration.page_height}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>

            <label className={styles.selectLabel}>
              Page Width
              <input
                name="page_width"
                className={styles.numberInput}
                type="text"
                maxLength="4"
                value={pageConfiguration.page_width}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Page Type
              <select
                name="page_type"
                className={styles.select}
                value={pageConfiguration.page_type}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value,
                  })
                }
              >
                <option value="V">Flexible Height</option>
                <option value="F">Fixed Height</option>
              </select>
            </label>
            <label className={styles.selectLabel}>
              Page Orientation
              <select
                name="orientation"
                className={styles.select}
                value={pageConfiguration.orientation}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value,
                  })
                }
              >
                <option value="P">Portrait</option>
                <option value="L">Landscape</option>
              </select>
            </label>
          </div>
          <button className={styles.submit}>Save changes</button>
        </div>
      </div>
    </form>
  );
};

export default PageConfigurationForm;
